import { render, staticRenderFns } from "./AffiliatesList.vue?vue&type=template&id=77bdc8a0&scoped=true"
import script from "./AffiliatesList.vue?vue&type=script&lang=js"
export * from "./AffiliatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bdc8a0",
  null
  
)

export default component.exports